export default class SliderCompareProducts
{
  constructor()
  {
    if (!this.setVars()) return;
    
    this.setEvents();
  }
  
  setVars()
  {
    this.settings = {
      main: 'data-compare-products',
      wrapper: 'data-compare-products-wrapper',
      arrows: 'data-compare-products-arrows',
      arrowLeft: 'data-compare-products-arrow-left',
      arrowRight: 'data-compare-products-arrow-right',
      dotsContainer: 'data-compare-products-dot-container',
      dot: 'data-compare-products-dot',
    };
    
    this.sliders = document.querySelectorAll(`[${this.settings.main}]`);
    if (!this.sliders) return;
    
    return true;
  }
  
  setEvents()
  {
    this.sliders.forEach(elWrapper => {
      const wrapper = elWrapper.querySelector(`[${this.settings.wrapper}]`);
      const settings = {
        container: wrapper,
        controls: false,
        slideBy: 1,
        startIndex: 1,
        autoplayText: ['', ''],
        autoplay: false,
        touch: false,
        mouseDrag: false,
        gutter: 16,
        nav: false,
        loop: true,
        responsive: {
          320: {
            items: 1,
            startIndex: 0,
            center: true,
            touch: true,
            gutter: 16,
          },
          767: {
            items: 2,
            mouseDrag: true,
            center: false,
            gutter: 16,
          },
          1023: {
            items: 3,
            gutter: 16,
          }
        }
      };
      
      const slider = this.initSlider(settings);
      const arrowRight = elWrapper.querySelector(`[${this.settings.arrowRight}]`);
      const arrowLeft = elWrapper.querySelector(`[${this.settings.arrowLeft}]`);
      this.checkHeight();
      
      if (arrowRight) {
        arrowRight.addEventListener('click', () => {
          slider.goTo('next');
        });
      }
      
      if (arrowLeft) {
        arrowLeft.addEventListener('click', () => {
          slider.goTo('prev');
        });
      }
  
      slider.events.on('indexChanged', (info) => {
        elWrapper.querySelectorAll(`[${this.settings.dot}]`).removeClass('active');
        elWrapper.querySelector(`[${this.settings.dot}="${info.displayIndex - 1}"]`).addClass('active');
        this.checkHeight();
      });
  
      elWrapper.querySelectorAll(`[${this.settings.dot}]`).forEach((dot) => {
        dot.addEventListener('click', (e) => {
          const numberSlide = parseInt(e.target.getAttribute(this.settings.dot));
          slider.goTo(numberSlide);
        })
      });
    })
  }
  
  checkHeight() {
    const height = {};
    let heightHead = 0;
    document.querySelectorAll(`[data-compare-label]`).forEach(item => {
      item.style.minHeight = `87px`;
    });
    
    document.querySelectorAll('.tns-slide-active').forEach((item) => {
      item.querySelectorAll('.cartProduct').forEach(cart => {
        if (heightHead < cart.offsetHeight) {
          heightHead = cart.offsetHeight + 2;
        }
      });
      
      item.querySelectorAll('[data-compare-label]').forEach((label) => {
        if (!height[label.getAttribute('data-compare-label')] || height[label.getAttribute('data-compare-label')] < label.offsetHeight) {
          height[label.getAttribute('data-compare-label')] = label.offsetHeight
        }
      });
    });
    
    document.querySelector('.compareProducts__emptyProduct ').style.paddingTop = `${heightHead}px`
  
    for (const [key, value] of Object.entries(height)) {
      document.querySelectorAll(`[data-compare-label="${key}"]`).forEach(item => {
        item.style.minHeight = `${value}px`;
      });
    }
  }
  
  initSlider(settings) {
    return tns(settings);
  }
}
